import { createAsyncThunk } from '@reduxjs/toolkit'
import { WorkingStepsController } from 'controllers/WorkingStepsController'
import { BomItemType } from 'model/Project/BoMItemRow'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { ReplaceWorkingStepDataResult } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from '../selectors/bomItemSelector'
import { partInstancePartTypeSelector } from '../selectors/partInstancePartTypeSelector'
import { fetchProject } from './fetchProject'

export const replaceWorkingStepDataToOtherParts = createAsyncThunk<
  ReplaceWorkingStepDataResult,
  { bomItemPointer: BomItemPointer; activityId: string },
  { state: RootAppState }
>(
  'bom/replaceWorkingStepDataToOtherParts',
  async ({ bomItemPointer, activityId }, thunkAPI) => {
    const state = thunkAPI.getState()
    const source = partInstancePartTypeSelector(bomItemPointer)(state)
    const item = bomItemSelector(state, source)
    const parent = item && bomItemSelector(state, item.parentBomItemPointer)
    if (
      item?.type !== BomItemType.partType ||
      (parent?.type !== BomItemType.assemblyType &&
        parent?.type !== BomItemType.materialHeader)
    ) {
      throw new Error('No filtered destination parts are available')
    }
    const destinations = parent.filteredPartTypePointers
      .map((pointer) => partInstancePartTypeSelector(pointer)(state))
      .filter(
        (pointer) =>
          pointer.type === BomItemType.partType && pointer.id !== source.id,
      )
    if (destinations.length === 0) {
      return { updatedActivities: 0, updatedItems: 0, skippedItems: 0 }
    }
    const result =
      await new WorkingStepsController().ReplaceWorkingStepDataToOtherParts(
        source,
        activityId,
        destinations,
      )
    if (result.updatedActivities > 0) {
      await thunkAPI.dispatch(
        fetchProject({ projectId: state.project.activeProject.id }),
      )
    }
    return result
  },
)
